import { HStack, VStack } from "IZOX/_X";
import { useCallback, useState } from "react";

/**
 * @typedef {import("./HStack").hstackparams} hstackparams
 * @typedef {import("./VStack").vstackparams} vstackparams
 * 
 * @typedef {Object} xdropzoneparamsAddOns
 * @property {(e) => void} onDrop
 * @property {"H" | "V"} direction
 * @property {(isDragOver: boolean) => hstackparams | vstackparams} paramAddOns
 * 
 * @typedef {hstackparams & vstackparams & xdropzoneparamsAddOns} xdropzoneparams
 * 
 * @param {xdropzoneparams} param0 
 * @returns 
 */
function XDropZone({
  children,
  onDrop,
  direction = "V",
  paramAddOns, 
  active = true,
  ...others
}){

  const [isDragOver, setIsDragOver] = useState(false);

  const _onDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if(active){
      setIsDragOver(false);
      onDrop?.(e);
    }
  }, [onDrop, active]);

  const _onDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if(active){
      setIsDragOver(true);
    }
  }, [active]);

  const _onDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if(active){
      setIsDragOver(true);
    }
  }, [active]);

  const _onDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if(active){
      setIsDragOver(false);
    }
  }, [active]);

  if(direction === "V"){
    return (
      <VStack 
        onDrop={_onDrop}
        onDragOver={_onDragOver}
        onDragEnter={_onDragEnter}
        onDragLeave={_onDragLeave}
        {...others} {...paramAddOns?.(isDragOver)}>
        {children}
      </VStack>
    );
  }else{
    return (
      <HStack 
        onDrop={_onDrop}
        onDragOver={_onDragOver}
        onDragEnter={_onDragEnter}
        onDragLeave={_onDragLeave}
        {...others} {...paramAddOns?.(isDragOver)}>
        {children}
      </HStack>
    );
  }
  
}

export default XDropZone;